import { Tooltip, Box } from "@mui/material"
import { Projeto } from "src/components/projetos/types"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"

interface InputCustoAnualManutencaoProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
}

function InputCustoAnualManutencao({ formState, setFormState }: InputCustoAnualManutencaoProps) {
  return (
    <Tooltip title="Informação utilizada para calcular o retorno do investimento.">
      <Box>
        <InputDecimal3
          InputLabelProps={{ shrink: true }}
          label={`* Custo anual com manutenção`}
          margin="normal"
          decimal={2}
          maxLength={15}
          placeholder="R$ 0,00"
          prefix={formState.valor_anual_manutencao ? <>R$&nbsp;</> : ''}
          value={formState.valor_anual_manutencao ? String(formState.valor_anual_manutencao) : ''}
          onChange={(event: any) => {
            const normalized = event.target.value ? Number(event.target.value.replace(',', '.')) : 0
            setFormState({ valor_anual_manutencao: normalized })
          }}
        />
      </Box>
    </Tooltip>
  )
}

export { InputCustoAnualManutencao }